import { render, staticRenderFns } from "./WV-PH-Notice.vue?vue&type=template&id=3950122f&scoped=true&"
import script from "./WV-PH-Notice.vue?vue&type=script&lang=js&"
export * from "./WV-PH-Notice.vue?vue&type=script&lang=js&"
import style0 from "./WV-PH-Notice.vue?vue&type=style&index=0&id=3950122f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3950122f",
  null
  
)

export default component.exports